<template>
  <sidebar :title="`Top Up ${selectedRetailer?.name || ''} Balance`" :show="showTopUpRetailerSidebar" @on-close="close"
    size="sm">
    <template v-slot:body>
      <div class="row">
        <div class="col">
          <div class="form-group">
            <label>Amount</label>
            <div class="mb-3">
              <input type="number" class="form-control" :disabled="submitting" v-model="amount" min="0"
                @focus="$event.target.select()" @keydown="preventNegative($event)" />
            </div>
          </div>
        </div>
      </div>

      <div class="text-center">
        <button type="button" class="btn bg-info bg-violet text-white w-100 mt-4 mb-0" @click="submitRetailer">

          <div class="spinner-border spinner-border-sm" role="status" v-if="submitting">
            <span class="sr-only">Loading...</span>
          </div>

          Submit
        </button>
      </div>
    </template>
  </sidebar>
  <GlobalModal :show="modal.show" :title="modal.title" :message="modal.message" :type="modal.type"
    @confirm="modal.onConfirm" @cancel="modal.onCancel" @close="modal.show = false" />
</template>

<script>
import sidebar from "../../../../../components/sidebar.vue";
import { mapActions, mapMutations, mapState } from "vuex";
import GlobalModal from "@/components/GlobalModal.vue";

export default {
  components: {
    sidebar,
    GlobalModal
  },
  data() {
    return {
      amount: 0,
      modal: { show: false, type: 'success', title: '', message: '' }
    };
  },
  computed: {
    ...mapState({
      showTopUpRetailerSidebar: (state) =>
        state.retailerController.showTopUpRetailerSidebar,
      submitting: (state) => state.retailerController.submitting,
      selectedRetailer: (state) => state.retailerController.selectedRetailer,
    }),
    sidebarTitle() {
      return this.selectedRetailer?.name
        ? `Top Up Balance - ${this.selectedRetailer.name}`
        : "Top Up Retailer Balance";
    },
  },
  methods: {
    ...mapActions({
      getRetailers: "retailerController/GetRetailers",
      updateRetailerBalance: "retailerController/UpdateRetailerBalance",
    }),
    ...mapMutations({
      setShowRetailerTopUpSidebar:
        "retailerController/SET_ShowRetailerTopUpSidebar",
      selectRetailer: "retailerController/SELECT_Retailer",
    }),
    close() {
      this.selectRetailer(null);
      this.setShowRetailerTopUpSidebar(false);
      this.amount = 0;
    },
    async submitRetailer() {
      var result = await this.updateRetailerBalance(this.amount).catch(
        (error) => {
          //alert(error.data.ErrorMessage);
          this.showModal
            (
              'error',
              `error.data.ErrorMessage`
            )
        }
      );
      if (result) {
        this.showModal(
          'success',
          `Retailer ${this.selectedRetailer?.name} successfully loaded.`,
        );
        await this.getRetailers();
        this.close();
      }
    },
    preventNegative(event) {
      if (event.key === "-" || event.key === "e") {
        event.preventDefault();
      }
    },
    showModal(type, title, message) {
      return new Promise((resolve) => {
        this.modal = {
          show: true,
          type,
          title,
          message,
          onConfirm: () => {
            this.modal.show = false;
            resolve(true);
          },
          onCancel: () => {
            this.modal.show = false;
            resolve(false);
          },
        };
      });
    }
  },
};
</script>

<style></style>
